import { makeStyles } from '@material-ui/core/styles'
import { CancelButton, ModalBase, Text } from '../../../components/1elements'
import ButtonLayoutDiv from '../../../components/4layout/ButtonLayoutDiv'
import SaveButton from '../../../components/1elements/Buttons/TextButtons/SaveButton'

const GenericMutationModalBase = ({
  header,
  children,
  cancelHandler,
  saveHandler,
  open,
  setOpen
}) => {
  const classes = useStyles()

  return (
    <ModalBase open={open} setOpen={setOpen}>
      <div className={classes.root}>
        <Text type='selectOwnerModalHeader'>{header}</Text>
        <div className={classes.contentDiv}>{children}</div>
        <ButtonLayoutDiv>
          <CancelButton onClick={cancelHandler} />
          <SaveButton onClick={saveHandler} />
        </ButtonLayoutDiv>
      </div>
    </ModalBase>
  )
}

export default GenericMutationModalBase

const useStyles = makeStyles({
  root: {
    padding: '10px'
  },
  contentDiv: {
    margin: '20px 0 40px',
    padding: '0 20px',
    maxWidth: '90vw',
    maxheight: '90vh',
    width: '85vw',
    height: '70vh',
    overflowY: 'auto'
  }
})
